<template class="bg-variant h-full">
  <div class="width" v-if="!loading">
    <div class="flex items-center justify-between">
      <span class="text-ssm:text-3xl lg:text-4xl tracking-widest font-bold title-font">
        Gestion des groupes
      </span>
      <div class="flex">
        <Button
          @click="$router.push(`/projects/${$route.params.idProject}/settings`)"
          icon="mdi-cog"
          :icon-size="24"
          label="Paramètres"
          class="mr-2"
        />
        <Button
          @click="$router.push(`/projects/${$route.params.idProject}/groups/${groupsLists[0].id}`)"
          icon="mdi-chevron-left"
          :icon-size="24"
          label="Retour"
        />
      </div>
    </div>
    <div>
      <span class="text-ssm:text-2xl lg:text-3xl tracking-widest font-bold title-font text-primary">
        Projet : "{{ project.title }}"
      </span>
    </div>
    <div style="height: 90%" class=" gestion_projet_container">
      <div class=" p-grid ">
        <div class="p-col-12 p-lg-6 responsive-gestion_project_container">
          <ScrollPanel class="ScrollForGroups" style="width: 100%; height: 500px !important;">
            <div v-for="groups in groupsLists"
                 :key="groups.id"
                 class=" bg-default bloc-list-groups p-grid relative"
                :class="{'bloc-selected': groupsDescription !== null && groups.id === groupsDescription.id}"
                @click="selectGroup(groups)">

              <!-- Titre -->
              <div class="self-center p-col-6 flex items-center">
                  <div v-if="groups.is_model" class="bloc-master-folder mr-2">
                    <v-mdi name="mdi-school"></v-mdi>
                  </div>
                  {{ groups.title }}
              </div>

              <!-- Avatars -->
              <div class=" p-text-center self-center  p-col-3">
                <AvatarGroup>
                  <Avatar v-for="members in groups.members.slice(0, 3)" :key="members.id"
                          :image="logo"
                          :style="{ 'background-color': members.color, 'padding': '6px' }"
                          shape="circle"/>
                  <Avatar v-if="groups.members.length > 3" label="+" shape="circle" size="24px"
                          style="background-color:#9c27b0; color: #ffffff"/>
                </AvatarGroup>
              </div>

              <!-- Boutons d'actions -->
              <div class="p-col-1">
                <Button v-if="isAdminOfProject && !groups.is_model" icon="mdi-delete" @click="openModalDeleteGroup(groups)" class=" p-button-link ">
                </Button>
              </div>
              <div v-if="isAdminOfProject" class="p-col-1">
                <Button icon="mdi-pencil" @click="selectGroup(groups)" class="p-button-link ">
                </Button>
              </div>
            </div>

            <!-- Nouveau groupe -->
            <div class="flex justify-end mt-4">
              <Button
                @click="displayModal = true"
                icon="mdi-plus"
                label="Nouveau groupe"
                class="p-button-rounded mx-2">
              </Button>
            </div>
          </ScrollPanel>
        </div>
        <div class="p-col-12 p-lg-6 bloc-detail-groups mt-0 p-4" v-if="groupsDescription && isAdminOfProject">
          <div v-if="groupsDescription " class="p-grid">
            <div class=" p-col-12 font-bold text-3xl">
              <InputText class="group-description-title-input" type="text"
                         v-model="groupsDescription.title"/>
            </div>
            <!--
            <div class="p-col-12">
              <div class="  bloc-detail-groups_check  p-grid">
                <div class="p-col-6">
                  <div class=" p-field-checkbox flex bloc-detail-groups_checbox">
                    <Checkbox v-model="groupsDescription.is_visible"
                        id="group_is_visible"
                        @change="displayButtonSave = !displayButtonSave" :binary="true"/>
                    <label for="group_is_visible">
                      Code visible par les autres
                    </label>
                  </div>
                </div>
                <div class="p-col-6">
                  <div class=" p-field-checkbox flex bloc-detail-groups_checbox">
                    <Checkbox id="group_is_locked" v-model="groupsDescription.is_locked" :binary="true" />
                    <label for="group_is_locked">
                      Verrouiller l'édition du code
                    </label>
                  </div>
                </div>
              </div>
            </div>
            -->
            <div class="ScrollForMembers" style="width: 100%; height: 335px !important;">
              <div v-for="member in groupsDescription.members" :key="member.id" class="p-col-12">
                <div class="flex items-center">
                  <div class="responsive-icon-div">
                    <Avatar
                        :image="logo"
                        size="xlarge"
                        class="responsive-icon"
                        shape="circle"
                        :style="{ 'background-color': member.color }"
                    />
                  </div>
                  <div class="p-col pl-3">
                    <div class="flex-col">
                      <p class="text-2xl leading-6 responsive-full-name">
                        <strong>{{ member.username }}</strong>
                        <br>
                        <small class="text-gray-400">({{ member.email }})</small>
                      </p>
                    </div>
                  </div>
                  <div class="p-inputgroup choose-role">
                    <Dropdown :value="member.role.role_id"
                              @input=" member.role.role_id = $event"
                              option-value="id" optionLabel="name"
                              @change="changeValueRole(member, $event)" :options="role">
                    </Dropdown>
                    <Button icon="mdi-chevron-down" class="p-button">
                    </Button>
                  </div>
                  <div class="responsive-delete p-button-custom-delete ml-5" v-if="!groupsDescription.is_model && member.id !== project.creator_user_id">
                    <Button icon="mdi-delete" @click="openModalDeleteMembers(member.id)">
                    </Button>
                  </div>
                </div>
              </div>
              <div class="w-full flex justify-end mt-4">
                <Button icon="mdi-plus" label="Ajouter un membre" class="p-button mx-2" @click="openModal = true"></Button>
              </div>
            </div>
            <hr>
            <div class="w-full flex justify-end">
              <Button @click="SendChange()" label="Enregistrer"
                    icon="mdi-content-save" class="p-button-rounded ml-2 mx-2 bg-validate btn-green">
              </Button>
            </div>
          </div>
          <div v-else>
            <div class=" p-col-12 font-bold text-3xl">Selectionnez un groupe pour voir ses membres:
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Suppression d'un groupe" :visible.sync="displayConfirmation"
            :style="{ width: '40%' }" :modal="true">
      <div class="confirmation-content flex items-center">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
        <span>Souhaitez-vous supprimer le groupe ?</span>
      </div>
      <template #footer>
        <Button label="Annuler"
                icon="mdi-close"
                class="p-button-text"
                @click="displayConfirmation = false" />
        <Button
          label="Supprimer"
          icon="mdi-delete"
          autofocus
          @click="deleteGroups" />
      </template>
    </Dialog>
    <Dialog header="Suppression d'un membre" :visible.sync="displaySuppMembers"
            :style="{ width: '40%' }" :modal="true">
      <div class="confirmation-content flex items-center">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
        <span>Souhaitez-vous retirer le membre de ce groupe ?</span>
      </div>
      <template #footer>
        <Button label="Annuler"
                icon="mdi-close"
                class="p-button-text"
                @click="displaySuppMembers = false" />
        <Button
          label="Retirer"
          icon="mdi-delete"
          autofocus
          @click="deleteUsers" />
      </template>
    </Dialog>
    <ModalAddUser @groupDescriptionUpdate="updateGroup" @projectUpdate="projectUpdate"
                  :project_id="project.id" :group="groupsDescription"
                  :usersList="usersList" :openModal="openModal" @close="closeModal"
                  @changeModal="openModal = true"></ModalAddUser>
    <ProjectCreate @reloadProjet="reloadProject"  :displayModal="displayModal" @close="displayModal = false"></ProjectCreate>
  </div>

  <!-- Skeleton -->
  <GroupsSkeleton v-else ></GroupsSkeleton>
</template>
<script>
import Multiselect from 'vue-multiselect'
import NavBarProject from '@/components/Layout/NavBarProject'
import ModalAddUser from '@/components/ModalAddUser'
import ProjectCreate from "./ProjectCreate"
import GroupsSkeleton from '@/components/GroupsSkeleton'
import logo from "~/assets/img/avatars/face-1.svg"
import {
  mapGetters
} from 'vuex'

export default {
  watch: {},
  components: {
    GroupsSkeleton,
    ProjectCreate,
    ModalAddUser,
    Multiselect,
    NavBarProject
  },
  data() {
    return {
      loading: true,
      displayModal: false,
      displaySuppMembers: false,
      openModal: false,
      logo: logo,
      checkbox: false,
      modalOpen: false,
      selectorIsLoading: false,
      groupsLists: [],
      groupsDescription: null,
      project: false,
      membersChanging: [],
      displayButtonSave: true,
      default_data: false,
      displayConfirmation: false,
      members_id: null,
      role: []
    }
  },
  computed: {
    ...mapGetters({
      user_id: 'auth/id'
    }),
    projects_members() {
      return this.project.members
    },
    isAdminOfProject() {
      return this.project.members.some(members => members.pivot.user_id === this.user_id && members.pivot.is_admin === 1)
    },
    usersList() {
      return this.project?.members.filter(member => {
        return member.groups.length === 0
      })
    }
  },
  methods: {
    reloadProject() {
      this.loading = true
      setTimeout(() => {
        this.getProject()
      }, 500)
    },
    openModalDeleteGroup(group) {
      this.displayConfirmation = true
      this.selectGroup(group)
    },
    openModalDeleteMembers(member_id) {
      this.displaySuppMembers = true
      this.members_id = member_id
    },
    projectUpdate(value) {
      this.project = value
      this.$toast.add({
        severity: 'success',
        position: "bottom-center",
        summary: 'Membre(s) ajouté(s)',
        detail: 'La liste des membres à bien été modifiées',
        life: 3000
      })
      this.groupsLists = value.groups
    },
    closeModal() {
      this.openModal = false
    },
    selectGroup(group) {
      this.updateGroup(group.id)
    },
    changeValueRole(member, event) {
      const membersSend = {}
      membersSend['user_id'] = member.id
      membersSend['role_id'] = member.role.role_id
      const index = this.membersChanging.findIndex(it => it.user_id === member.id);
      if (index === -1) {
        this.membersChanging.push(membersSend)
      } else {
        this.membersChanging[index] = membersSend
      }
    },
    updateGroup(group_id) {
      this.$store.dispatch('projects/get_group', group_id).then((res) => {
        const group = res.group
        this.groupsDescription = {
          ...group,
          is_visible: !!group.is_visible,
          is_locked: !!group.is_locked
        }
      })
    },
    deleteGroups() {
      this.$store.dispatch('projects/delete_group', this.groupsDescription.id).then(() => {
        this.getProject()
        this.$toast.add({
          severity: 'success',
          position: "bottom-center",
          summary: 'Suppression éffectuée',
          detail: 'Le groupe a bien été supprimé du projet',
          life: 3000
        })
        this.displayConfirmation = false
        this.groupsDescription = false
      })
    },
    SendChange() {
      const groupModif = {}
      groupModif.title = this.groupsDescription.title
      groupModif.description = this.groupsDescription.description
      groupModif.is_visible = this.groupsDescription.is_visible
      groupModif.is_locked = this.groupsDescription.is_locked
      groupModif.members = this.membersChanging
      this.$store.dispatch('projects/update_group', {
        group_id: this.groupsDescription.id,
        group_update: groupModif
      }).then((r) => {
        this.getProject(this.groupsDescription.id)
        this.$toast.add({
          severity: 'success',
          position: "bottom-center",
          summary: 'Sauvegarde effectuée',
          detail: 'Les informations du groupe ont bien été modifiées',
          life: 3000
        })
      })
    },
    async getProject(groupId = null) {
      await this.$store.dispatch('projects/get_project', this.$route.params.idProject).then((res) => {
        this.project = res
        this.groupsLists = res.groups

        // open first group details by default
        if (!groupId) groupId = res.groups['0'].id
        this.updateGroup(groupId)

        this.loading = false
      })
    },
    async deleteUsers() {
      const payload = {
        group_id: this.groupsDescription.id,
        user_id: this.members_id,
        project_id: this.project.id
      }
      await this.$store.dispatch('projects/delete_members_from_groups', payload)
        .then(async (r) => {
          this.$toast.add({
            severity: 'success',
            summary: 'Suppression éffectuée',
            detail: 'Le membre a bien été retiré du groupe',
            life: 3000
          })
          await this.getProject()
          await this.updateGroup(payload.group_id)
          this.displaySuppMembers = false
        })
    }
  },
  async created() {
    this.$store.dispatch('projects/get_roles').then((res) => {
      this.role = res
    })
    await this.getProject()
    if (this.project.members.some(members => members.user_id === this.user_id)) {
      await this.$router.push({ name: '401 Non autorisé' })
    }
  },
};
</script>
<style>

</style>
